import(/* webpackMode: "eager" */ "/codebuild/output/src820538367/src/SkillBridger/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src820538367/src/SkillBridger/node_modules/next/dist/client/link.js");
